export const FAMILY_MEMBER_TEMPLATE = {
    name: "",
    relation: "",
    birthday: "",
};

export const INITIAL_STATE = {
    // General Info Section
    firstName: "",
    lastName: "",
    email: "",
    birthday: "",
    phone: "",
    income: "",
    gender: null, // Stores Select object
    relationshipStatus: null, // Stores Select object
    isMinor: null,

    // Family Section
    livesAlone: null, // Boolean-like state
    familyInformation: [], // Array of FAMILY_MEMBER_TEMPLATE objects

    // Address Section
    streetAddress: "",
    streetAddress2: "",
    city: "",
    state: null, // Stores Select object
    zip: "",

    // Medical Info Section
    bleedingDisorder: null, // Boolean-like state
    // Note: The original component initialized these select-driven fields with "", 
    // which is reflected here.
    bleedingDisorderRelationship: "", 
    bleedingDisorderType: "", 
    bleedingDisorderSeverity: "", 
    HTC: "",

    // Application Info Section
    type: null, // Stores Select object
    method: null, // Stores Select object
    amount: "",
    details: "",
    otherApplication: null, // Boolean-like state
    otherLocations: "",

    // Attachments
    attachments: [], // Array of File objects
    attachmentError: false,
    attachmentErrorMessage: "",

    // Referral
    referred: null, // Boolean-like state
    referrer: "",
    permissions: null, // Boolean-like state
    permissionError: null,

    // Submission Handling (UI/Meta State)
    error: false,
    errorMessage: "",
    submitted: false,
    token: "",
    newsletterOptIn: false,
};